import { useEffect, useState } from 'react';

/**
 * This hook uses window.visualViewport:
 * https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API
 *
 * window.visualViewport is supported on ios 13+ and all android versions with a Chrome installation newer than
 * version 61 (06.09.2017). This means you have to implement a fallback for unsupported devices.
 *
 * In this hook desktop display is set to default.
 */

export const canUseVisualViewport = !!window?.visualViewport;

const useViewportSize = (): Readonly<[number, number]> => {
    const [size, setSize] = useState<Readonly<[number, number]>>([window.innerWidth, window.innerHeight]);

    useEffect(() => {
        const handleResize = () => setSize([window.innerWidth, window.innerHeight]);

        if (canUseVisualViewport) window.visualViewport!.addEventListener('resize', handleResize);
        return () => {
            if (canUseVisualViewport) window.visualViewport!.removeEventListener('resize', handleResize);
        };
    }, []);

    return size;
};

export default useViewportSize;
